import React, { useState } from 'react';
import { Button } from 'src/ui/Button';
import { Textarea } from 'src/ui/Textarea';
import Select from 'react-select';
import _transform from 'lodash/transform';

export interface ProfileFieldProps {
  fieldKey: string;
  fieldValue: string;
  fieldOptions?: any;
  enableDelete: boolean;
  onChange: (key: any, value: any) => void;
  onDelete?: (key: any) => void;
}

const ProfileField = ({
  fieldKey,
  fieldValue,
  fieldOptions,
  enableDelete = true,
  onChange = () => null,
  onDelete = () => null,
}: ProfileFieldProps) => {
  const [active, setActive] = useState(false);

  const handleChange = (e: any) => {
    onChange(fieldKey, e.target.value);
  };

  const handleOptionChange = (selected: any) => {
    if (selected instanceof Array) {
      const value = selected.reduce((acc, cur) => (acc |= 1 << cur.value), 0);
      onChange(fieldKey, value);
    } else {
      onChange(fieldKey, selected.value);
    }
  };

  const handleDelete = (e: any) => {
    onDelete(fieldKey);
  };

  const renderControl = () => {
    if (fieldOptions) {
      const isBinary = fieldOptions[1]?.[0] <= 2;
      let defaultValue = isBinary
        ? fieldOptions.reduce((acc: any, cur: any) => {
            if (Number(fieldValue) & Math.pow(2, cur[0])) {
              acc.push({
                value: cur[0],
                label: cur[1].cn,
              });
            }
            return acc;
          }, [])
        : _transform(
            fieldOptions,
            (result: any, option) => {
              if (fieldValue === option[0]) {
                result.push({
                  value: option[0],
                  label: option[1].cn,
                });
                return false;
              }
              return true;
            },
            []
          );
      if (fieldValue && (!defaultValue || defaultValue.length === 0)) {
        defaultValue = [
          {
            value: fieldValue,
            label: fieldValue,
          },
        ];
      }
      return (
        <>
          <Select
            isMulti={isBinary}
            closeMenuOnSelect={!isBinary}
            defaultValue={defaultValue}
            onChange={handleOptionChange}
            options={fieldOptions.map((label: any) => ({
              value: label[0],
              label: label[1].cn,
            }))}
          />
          <div
            style={{
              fontSize: 'var(--fs-xs)',
              color: 'var(--text-muted)',
              marginTop: 4,
            }}
          >
            Value: {fieldValue}
          </div>
        </>
      );
    } else {
      return (
        <Textarea
          placeholder="N/A"
          value={fieldValue}
          onChange={handleChange}
          style={{ width: '100%', minWidth: 100 }}
        />
      );
    }
  };

  return (
    <div
      style={{ width: '100%' }}
      onMouseOver={() => setActive(true)}
      onMouseOut={() => setActive(false)}
    >
      <label
        style={{
          display: 'block',
          fontSize: 'var(--fs-sm)',
          color: 'var(--text-secondary)',
          marginBottom: 4,
        }}
      >
        {fieldKey}
      </label>
      {renderControl()}
      {enableDelete && active && (
        <Button
          variant="secondary"
          size="sm"
          leftIcon="trash"
          onClick={handleDelete}
          style={{
            marginTop: 8,
            marginLeft: 8,
            color: 'var(--red-solid, #dc2626)',
          }}
        >
          Delete
        </Button>
      )}
    </div>
  );
};

export default ProfileField;
